import React from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { palette } from "../../../theme/palette";
import { WaveIcon } from "../../Icons";
import { View } from "../../Base";
import SingleWavePopover from "./SingleWavePopover";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  waveIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const SingleWaveComponent = ({ singleWaveAreas }) => {
  const styles = useStyles();
  const [waveAnchorEl, setWarningAnchorEl] = React.useState(null);

  return (
    <View className={styles.container}>
      <WaveIcon
        className={clsx(
          styles.infoIcon,
          styles.waveIcon,
          waveAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) =>
          !!singleWaveAreas?.length && setWarningAnchorEl(event.currentTarget)
        }
      />
      {singleWaveAreas?.length || 0}
      <SingleWavePopover
        singleWaveAreas={singleWaveAreas}
        open={!!waveAnchorEl}
        onClose={() => setWarningAnchorEl(null)}
        anchorEl={waveAnchorEl}
      />
    </View>
  );
};

export default SingleWaveComponent;
